import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

/**
 * 判断是否应该在页面显示「返回上一页」按钮（只在 web 生效）
 * 逻辑：
 * - 非 web 环境（APP、原生）始终返回 false
 * - 优先判断 document.referrer 是否来自当前 origin
 * - 其次判断 sessionStorage 中的站内导航标记（cm_last_nav_internal）是否存在
 */
export default function useShowBackButton(): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (Platform && (Platform as any).OS && (Platform as any).OS !== 'web') {
        setShow(false);
        return;
      }

      if (typeof window === 'undefined' || typeof document === 'undefined') {
        setShow(false);
        return;
      }

      const origin = window.location.origin || '';
      const ref = document.referrer || '';
      const refIsInternal = ref && origin && ref.startsWith(origin);

  const lastInternal = sessionStorage.getItem('cm_last_nav_internal');
  const internalMarkExists = !!lastInternal;

  setShow(Boolean(refIsInternal || internalMarkExists));
    } catch (e) {
      setShow(false);
    }
  }, []);

  return show;
}
